import React from 'react';
import { Col, Row } from 'react-bootstrap';
import SdkVersionTable from '../SdkVersionTable';
import SdkVersionEvolution from '../version/SdkVersionEvolution';
import AppVersionEvolution from '../version/AppVersionEvolution';
import DevicePerSdkVersion from '../version/DevicePerSdkVersion';
import DevicePerAppVersion from '../version/DevicePerAppVersion';
import EnabledBadge from '../../metrics/tables/cells/EnabledCell';
import { useTranslation } from 'react-i18next';

const VersionTab = ({appId, filter, setFilter}) => {

  const filterOnVersion = (sdk_version, app_version) => {
    setFilter({ ...filter, sdk_version: [sdk_version], app_version: [app_version] })
  }
  const { t } = useTranslation();
  const extraColumns=[
    {
      Header: t("stats.background_location_enabled"),
      Cell: ({row}) => (<EnabledBadge enabled={row.original.background_location_enabled} />),
      accessor: 'background_location_enabled'
    }
  ]

  return (
    <>
      <Row>
        <Col>
          <SdkVersionTable appId={appId} filter={filter} extraColumns={extraColumns} onRowClick={(row)=> filterOnVersion(row.sdk_version, row.app_version)}/>
        </Col>
      </Row>
      <Row>
        <Col>
          <SdkVersionEvolution appId={appId} filter={filter}/>
        </Col>
        <Col>
          <DevicePerSdkVersion appId={appId} filter={filter}/>
        </Col>
      </Row>
      <Row>
        <Col>
          <AppVersionEvolution appId={appId} filter={filter} />
        </Col>
        <Col>
          <DevicePerAppVersion appId={appId} filter={filter} />
        </Col>
      </Row>
    </>
  )
}

export default VersionTab
